import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { IUser } from '../interfaces';
import { IUserState } from '../state/user.reducer';
import { IOktaToken, IClaims } from '@app/auth/interfaces';
import { WINDOW } from '@app/lib/services/window.service';
import * as UserActions from '../state/user.actions';
import * as userSelectors from '../state/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user$: Observable<IUser>;
  superuser$: Observable<boolean>;

  constructor(

    @Inject(WINDOW)
    private readonly window: Window,

    private readonly store: Store<IUserState>
  ) {
    this.user$ = this.store.select(userSelectors.user);
    this.superuser$ = this.store.select(userSelectors.superuser);
  }

  getUser(): void {
    this.store.dispatch(UserActions.getUser());
  }

  _getUser(): Observable<IUser> {
    const storageData: IOktaToken = JSON.parse(this.window.localStorage.getItem('okta-token-storage'));
    const idTokenClaims: Pick<IClaims, 'email' | 'name'> = storageData.idToken.claims;
    const accessTokenClaims: Pick<IClaims, 'app_role'> = storageData.accessToken.claims;

    const user: IUser = {
      app_role: accessTokenClaims?.app_role || '',
      email: idTokenClaims?.email || '',
      name: idTokenClaims?.name || '',
    };

    return of(user);
  }
}
